<template>
  <div>
    <!-- Stats Start -->
    <div class="row mb-4">
      <div class="col-md-2 d-flex align-items-center">
        <div class="mt-2">
          <h3 class="latest-activity-title">Latest Transaction</h3>
        </div>
      </div>
      <div class="col-md-2"></div>
      <div class="col-md-2">
        <div class="mt-4"></div>
      </div>
      <div class="col-md-2">
        <div class="mt-4"></div>
      </div>
      <div class="col-md-2">
        <div class="mt-4"></div>
      </div>
      <div class="col-md-2">
        <div class="mt-4"></div>
      </div>
    </div>
    <!-- Stats End -->

    <!-- Table Start -->
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="bg-white box-content scan-history-table-wrapper">
          <div class="latest-activity-toolbar">
            <div class="latest-activity-search-container" style="margin-bottom: 20px">
              <i class="fa fa-search search-prefix-icon"></i>
              <input
                class="form-control latest-activity-search-input"
                type="search"
                placeholder="Search Serial Number"
                aria-label="Search"
                v-model="search"
              />
            </div>
          </div>
          <div style="overflow-x: auto; overflow-y: hidden">
            <table class="table scan-history-table" style="margin: 0">
              <thead>
                <tr>
                  <th @click="toggleSort" style="padding-left: 20px; cursor: pointer; width: 200px">
                    Scan Date
                    <span class="sort asc" v-if="sortOrder === false">
                      <svg
                        fill="#000000"
                        height="8"
                        width="8"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 330 330"
                        transform="rotate(180)"
                      >
                        <path
                          d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                        />
                      </svg>
                    </span>
                    <span class="sort" v-else>
                      <svg
                        fill="#000000"
                        height="8"
                        width="8"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 330 330"
                      >
                        <path
                          d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"
                        />
                      </svg>
                    </span>
                  </th>
                  <th>Product Name</th>
                  <th>Serial Number</th>
                  <th>Device</th>
                  <th>Province</th>
                  <th>
                    Status
                    <b-button
                      variant="link"
                      class="p-0"
                      id="latest-activity-status"
                      v-b-tooltip.hover
                      :title="tooltipText"
                    >
                      <i class="fal fa-info-circle" style="color: #e6e6e6"></i>
                    </b-button>
                    <b-tooltip
                      target="latest-activity-status"
                      triggers="hover"
                      custom-class="left-aligned-tooltip tooltip-status"
                      html
                    >
                      <h5 class="tooltip-header">Status</h5>
                      <p><span class="genuine-status">Genuine</span></p>
                      <p class="label-status">Product Spare Part terdeteksi asli</p>
                      <p>
                        <span class="not-found-status">Counterfeit/Not Found</span>
                      </p>
                      <p class="label-status">
                        Product Spare Part tidak ditemukan dalam sistem database
                      </p>
                      <p><span class="fake-status">Counterfeit/Fake</span></p>
                      <p class="label-status">
                        Product Spare Part terdeteksi palsu atau counting scan lebih dari 5
                      </p>
                    </b-tooltip>
                  </th>
                  <th style="text-align: left">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(activity, index) in paginatedActivities" :key="index">
                  <td style="padding-left: 20px">
                    {{ activity.scan_date }}
                  </td>
                  <td class="name-column">
                    <div class="d-flex align-items-center">
                      <img
                        v-if="activity.product_image"
                        :src="activity.product_image"
                        alt="Product Image"
                        class="activity-product-image"
                      />
                      <span>{{ activity.product_name }}</span>
                    </div>
                  </td>
                  <td>{{ activity.serial_number }}</td>
                  <td>{{ activity.device }}</td>
                  <td>{{ activity.nama_provinsi }}</td>
                  <td>
                    <span :class="getButtonClass(activity.status).class" @onclick="showTooltip">
                      {{ getButtonClass(activity.status).text }}
                    </span>
                  </td>
                  <td style="text-align: left">
                    <button
                      class="latest-activity-action-button"
                      @click="showMap(activity)"
                      title="Show Map"
                    >
                      <img
                        :src="mapPinIcon"
                        alt="Show map location"
                        class="latest-activity-action-icon"
                      />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row pagination-divider" v-if="activities.length">
            <div
              class="col-12 d-flex align-items-center justify-content-between flex-wrap mb-3 pl-3 pr-3"
            >
              <div class="d-flex align-items-center flex-wrap">
                <span class="view-per-page-text mr-2">View</span>
                <select
                  v-model.number="pageSize"
                  @change="onPageSizeChange"
                  class="form-control form-control-sm latest-activity-limit"
                >
                  <option v-for="option in limitPerPageOptions" :key="option" :value="option">
                    {{ option }}
                  </option>
                </select>
                <span class="view-per-page-text ml-2">items per page</span>
              </div>
              <div class="d-flex align-items-center flex-wrap">
                <p class="mt-2 mb-2 view-per-page-text mr-3">Showing Page {{ currentPage }}</p>
                <nav class="pagination-minimal">
                  <ul class="pagination">
                    <li
                      class="page-item"
                      :class="{ disabled: currentPage <= 1 }"
                      @click.stop.prevent="changePage('prev')"
                    >
                      <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: currentPage >= totalPages }"
                      @click.stop.prevent="changePage('next')"
                    >
                      <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Map
      title="Latest Transaction Location"
      v-if="mapData"
      @closeModal="mapData = null"
      :data="mapData"
    />
    <!-- Table End -->
  </div>
</template>

<script>
import axios from "axios";
import Map from "./children/Map.vue";
import mapPinIcon from "@/assets/img/map_pin_icon.svg";

function debounce(fn, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

export default {
  metaInfo: {
    title: "Latest Activity",
  },
  components: {
    Map,
  },
  data() {
    return {
      activities: [],
      pageSize: 10,
      currentPage: 1,
      fullActivities: null,
      search: "",
      sortOrder: true,
      mapData: null,
      limitPerPageOptions: [10, 25, 50, 100],
      mapPinIcon,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.activities.length / this.pageSize);
    },
    paginatedActivities() {
      const sortedActivities = [...this.activities].sort((a, b) => {
        const dateA = new Date(a.scan_date);
        const dateB = new Date(b.scan_date);

        return this.sortOrder ? dateB - dateA : dateA - dateB;
      });

      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;

      return sortedActivities.slice(startIndex, endIndex);
    },
    sortedScanDate() {
      const sortedDates = [...this.activities.scan_date].sort((a, b) => {
        const dateA = new Date(a);
        const dateB = new Date(b);

        return this.sortOrder ? dateA - dateB : dateB - dateA;
      });

      return sortedDates;
    },
  },
  mounted() {
    this.fetchLastActivity();
    // this.sortedScanDate();
  },
  watch: {
    search: {
      handler: debounce(async function () {
        this.currentPage = 1;
        try {
          const response = await axios.get("/dashboard/last-activity", {
            params: { serial_number: this.search },
          });
          this.activities = response.data.data;
          if (!this.search) {
            this.fullActivities = JSON.parse(JSON.stringify(response.data.data));
          }
        } catch (error) {
          console.error("Error searching: ", error);
        }
      }, 1500),
      immediate: false,
    },
  },
  methods: {
    showMap(data) {
      console.log("hit");
      console.log("testing", data);
      this.mapData = data;
    },
    toggleSort() {
      this.sortOrder = !this.sortOrder;
    },
    async fetchLastActivity() {
      try {
        const response = await axios.get("/dashboard/last-activity");
        this.activities = response.data.data;
        this.fullActivities = JSON.parse(JSON.stringify(response.data.data));
      } catch (error) {
        console.error("Error fetching last activity:", error);
      }
    },
    onPageSizeChange() {
      this.currentPage = 1;
    },
    changePage(direction) {
      if (direction === "prev" && this.currentPage > 1) {
        this.currentPage -= 1;
        return;
      }

      if (direction === "next" && this.currentPage < this.totalPages) {
        this.currentPage += 1;
      }
    },
    getButtonClass(status) {
      // if (status === 'genuine') {
      //     return '"text-success bg-success-transparent-1 pr-3 pl-3 pt-1 pb-1';
      // } else if (status === 'fake') {
      //     return 'text-danger bg-danger-transparent-1 pr-3 pl-3 pt-1 pb-1';
      // } else if (status === 'fake_notfound') {
      //     return 'text-dark bg-dark-transparent-1 pr-3 pl-3 pt-1 pb-1';
      // } else {
      //     return 'text-dark bg-dark-transparent-1 pr-3 pl-3 pt-1 pb-1';
      // }

      let attributes = {
        class: "",
        text: "",
      };

      switch (status) {
        case "genuine":
          attributes.class = "genuine-status";
          attributes.text = "Genuine";
          break;
        case "fake":
          attributes.class = "fake-status";
          attributes.text = "Counterfeit/Fake";
          break;
        case "fake_notfound":
          attributes.class = "not-found-status";
          attributes.text = "Counterfeit/Not Found";
          break;
        default:
          attributes.class = "not-found-status";
          attributes.text = "Unknown";
          break;
      }

      return attributes;
    },
    showTooltip(param) {
      alert(param);
    },
  },
};
</script>

<style scoped>
.label-status {
  color: #9d9d9d;
  font-size: 12px;
}

.latest-activity-title {
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #4b4b4b;
}

.genuine-status {
  font-size: 0.85rem;
  background-color: #e3f4eb;
  color: #11782e;
  padding: 2px 10px;
  border-radius: 4px !important;
}

.fake-status {
  font-size: 0.85rem;
  background-color: #fff2f2;
  color: #f2060a;
  padding: 2px 10px;
  border-radius: 4px !important;
}

.not-found-status {
  font-size: 0.85rem;
  background-color: #eeeeee;
  color: #616161;
  padding: 1px 10px;
  border-radius: 4px !important;
}

.bg-success-transparent-1 {
  background-color: rgb(0 172 31 / 10%) !important;
}

.txt-success-2 {
  color: #28a745 !important;
}

.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.statsData {
  padding: 10px 7px;
}

.stats {
  font-size: 1.3rem;
  font-weight: 600;
}

.bg-kabupaten {
  background-color: darkorange;
}

.bg-kecamatan {
  background-color: blueviolet;
}

.bg-desakel {
  background-color: darkslategray;
}

.bg-tps {
  background-color: dodgerblue;
}

.column-region {
  height: 400px;
  overflow-y: scroll;
}

.latest-activity-toolbar {
  padding: 20px 20px 0 20px;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 0;
}

.latest-activity-search-container {
  position: relative;
  width: 250px;
}

.latest-activity-search-input {
  padding-left: 36px;
  border-color: #e8e8e8;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: #c9c9c9;
}

.latest-activity-search-input::placeholder {
  color: #c9c9c9;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
}

.search-prefix-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #cbcbcb;
  font-size: 14px;
}

.activity-product-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
  margin-right: 12px;
}

.latest-activity-action-button {
  border: none;
  background: transparent;
  padding: 0;
  width: 34px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.latest-activity-action-icon {
  width: 34px;
  height: 24px;
}

:deep(.scan-history-table-wrapper .scan-history-table) {
  font-family: "Inter", sans-serif !important;
}

:deep(.scan-history-table-wrapper .scan-history-table thead th) {
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  color: #4b4b4b !important;
  border-top: 1px solid #e6e6e6;
}

:deep(.scan-history-table-wrapper .table.scan-history-table tbody td) {
  font-family: "Inter", sans-serif !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  color: #393939 !important;
  border-bottom: 1px solid #e6e6e6 !important;
  border-top: none !important;
}

:deep(.scan-history-table-wrapper .table.scan-history-table tbody tr:last-child td) {
  border-bottom: none !important;
}

.pagination-divider {
  border-top: 1px solid #e6e6e6;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 16px;
  overflow: hidden;
}

.view-per-page-text {
  font-family: "Inter", sans-serif;
  color: #cbcbcb;
  font-weight: 400;
  font-size: 14px;
}

.pagination-minimal .pagination {
  margin-bottom: 0;
  flex-wrap: wrap;
}

.pagination-minimal .page-item {
  margin: 0 2px;
}

.pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4b4b4b;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  font-family: "Inter", sans-serif;
}

.pagination-minimal .page-item:not(.disabled) .page-link:hover {
  color: #007bff;
}

.pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9d9d9d !important;
}

.latest-activity-limit {
  width: auto;
  display: inline-block;
  padding: 4px 8px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #4b4b4b;
}
</style>

<style scoped>
.horizontal-line {
  border-top: 1px solid #a2a2a2;
  margin: 5px 0;
  width: 100%;
  height: 1px;
}

.ahm-table thead tr th {
  color: black !important;
  font-weight: normal !important;
  /* font-family: 'Proxima Nova' !important; Set the font family to Proxima Nova */
}

.table-title {
  font-weight: normal;
  color: #bcbcbc;
}

.ahm-table thead tr th,
.ahm-table tbody tr td {
  vertical-align: middle;
  font-size: 14px;
}

.ahm-table .no-border td {
  border: 0;
  padding: 5px;
}

.ahm-button-circular {
  width: 40px;
  /* Set the width and height to the same value for a perfect circle */
  height: 40px;
  border-radius: 50%;
  /* Makes the button circular */
  background-color: #d8e4ff;
  /* Sets the background color */
  padding: 10px 20px;
  /* Adjust padding to fit your content */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  outline: none;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  /* Adjust shadow values as needed */
}
</style>

<style>
.tooltip-status .tooltip-inner {
  max-width: 250px !important;
}
</style>
